// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cameraWrapDialogBackground {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.7;
    background-color: #000000;
    width: 100vw;
    height: 100vh;
    z-index: 2;
}

.cameraWrapDialogBox {
    position: fixed;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    border-radius: 1.25rem;
    padding: 2%;
    max-height: 95vh;
    max-width: 95vw;
}
.cameraWrapDialog_feed{
    max-height: calc(95vh - 5rem);
    width: auto;
}

.cameraWrapDialog_action {
    display: flex;
    justify-content: center;
    padding: 1% 2.5% 0;
}

.cameraWrapDialog_action_btn {
    text-align: center;
    background: transparent;
    padding: .8rem 2rem;
    cursor: pointer;
    border-radius: 1.15rem;
}

.camera_btn_left {
    background: #00127E;
    color: white;
    margin-right: 5%;
}

.camera_btn_left_disabled {
    background: #7c7c7c;
    color: black;
    margin-right: 5%;
}

.camera_btn_right {
    border: 1px solid #FF4425;
    color: #FF4425;
    margin-left: 5%;
}

.camera_switch_wrap {
    padding: 0;
}

.camera_switch_icn{
    padding: 0;
    object-fit: contain;
    opacity: 1;
    right: 2.5%;
    bottom: 0.1%;
    width: 9%;
}`, "",{"version":3,"sources":["webpack://./src/components/common/cameraWrap/styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;IACV,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,SAAS;AACb","sourcesContent":[".cameraWrapDialogBackground {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    opacity: 0.7;\n    background-color: #000000;\n    width: 100vw;\n    height: 100vh;\n    z-index: 2;\n}\n\n.cameraWrapDialogBox {\n    position: fixed;\n    z-index: 2;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    background: #FFFFFF;\n    border-radius: 1.25rem;\n    padding: 2%;\n    max-height: 95vh;\n    max-width: 95vw;\n}\n.cameraWrapDialog_feed{\n    max-height: calc(95vh - 5rem);\n    width: auto;\n}\n\n.cameraWrapDialog_action {\n    display: flex;\n    justify-content: center;\n    padding: 1% 2.5% 0;\n}\n\n.cameraWrapDialog_action_btn {\n    text-align: center;\n    background: transparent;\n    padding: .8rem 2rem;\n    cursor: pointer;\n    border-radius: 1.15rem;\n}\n\n.camera_btn_left {\n    background: #00127E;\n    color: white;\n    margin-right: 5%;\n}\n\n.camera_btn_left_disabled {\n    background: #7c7c7c;\n    color: black;\n    margin-right: 5%;\n}\n\n.camera_btn_right {\n    border: 1px solid #FF4425;\n    color: #FF4425;\n    margin-left: 5%;\n}\n\n.camera_switch_wrap {\n    padding: 0;\n}\n\n.camera_switch_icn{\n    padding: 0;\n    object-fit: contain;\n    opacity: 1;\n    right: 2.5%;\n    bottom: 0.1%;\n    width: 9%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
